// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/substance/dist/substance.css
// module id = 5
// module chunks = 0